import { View } from "src/binder/uiPatterns/mvvm/view";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { ViewModel } from "src/binder/uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { BinderPropertyDescriptor, IBinding } from "src/binder/binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { elementClassAdderRemover } from "./htmlClass";

export class AdditionalClassesHtmlBridgePrototype extends HtmlBridgePrototype{
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new AdditionalClassesHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}


class AdditionalClassesHtmlBridge extends HtmlBridge{
    
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:AdditionalClassesHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
    }
    public set classes(v: string) { 
        let oldClasses = this._classes ?? '';
        let newClasses = v;
        this._classes = v; 
        if(stringIsNullOrEmpty(oldClasses)==false){
            let oldClassesSplited = oldClasses.split(' ');
            oldClassesSplited.forEach(c => {
                new elementClassAdderRemover().removeClass(this.element,c);
            });
        }
        if(stringIsNullOrEmpty(newClasses)==false){
            let newClassesSplited = newClasses.split(' ');
            newClassesSplited.forEach(c => {
                new elementClassAdderRemover().addClass(this.element,c);
            });
        }
    } public get classes(): string { return this._classes;} private _classes: string;
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'classes'));
    }

    public release(){
        this.binding.release();
    }
}